<template>
  <div class="cw-map-filter" :class="{'is-visible': visible}">
    <div class="cw-map-filter-inner">
      <div class="cw-map-filter-rooms">
        <label v-for="room in $store.state.roomOptions" class="checkbox">
          <input type="checkbox" name="" :id="'room'+room" @change="toggleRoom(room)" checked>
          <!--<label :for="'room'+room"></label>-->
          {{room}} rok
          <span class="check"></span>
        </label>
      </div>

      <div class="cw-map-filter-custom">
        <!--<label v-for="(filter, id) in availableFilters" class="checkbox">
          <input type="checkbox" @change="onFilterChange(id)" :checked="filter.active" :name="id" :id="id">
          <span class="check"></span>
          {{filter.filter.label}}
        </label>-->

        <label v-for="lighter in availableLighters" class="checkbox">
          <input type="checkbox" @change="onLighterToggle(lighter.filter.key)" :checked="lighter.filter.key === activeLighter"
                 :name="lighter.filter.key" :id="lighter.filter.key">
          <span class="check"></span>
          {{lighter.filter.label}}
        </label>
      </div>

    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    name: 'MapFilter',
    props: ['visible'],
    data () {
      return {
        showAll: false
      }
    },
    computed: {
      ...mapGetters({
        objects: 'getObjects',
        activeLighter: 'getActiveLighter',
        availableFilters: 'getAvailableFilters',
        availableLighters: 'getAvailableLighters'
      })
    },
    created () {

    },
    mounted () {

    },
    methods: {
      onLighterToggle (id) {
        this.$store.commit('toggleLighter', id)
      },
      onFilterChange (id) {
        this.$store.commit('toggleFilter', id)
      },
      toggleFilter () {
        this.visible = !this.visible
      },
      toggleRoom (room) {
        this.$store.commit('toggleRoom', room)
      },
      toggleShowAll () {
        this.$store.commit('toggleShowAll', this.showAll)
      }
    },
    components: {}
  }
</script>



// WEBPACK FOOTER //
// src/components/MapFilter.vue